// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-page-subtitle{font-weight:var(--font-weight-primary-semibold)}@media screen and (min-width:769px){.gw-page-subtitle{margin-bottom:var(--spacing-md)}}.gw-page-subtitle.gw-page-subtitle--blue{color:var(--color-primary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
